import { type Content, EditorContent, useEditor } from '@tiptap/react';

import { extensions } from './extensions';

type Props = {
  content: Content;
};

/**
 * Unlike RichTextRenderer (tiptap's static renderer, JSONContent only), this mounts a read-only
 * tiptap editor, which also accepts an HTML string — for content fields still stored that way.
 */
export const LegacyRichTextRenderer = ({ content }: Props) => {
  const editor = useEditor({
    content,
    editable: false,
    extensions: extensions('renderer'),
  });

  return <EditorContent editor={editor} />;
};
